export default __webpack_public_path__ + "static/media/boule.3eb2f1b8.png";